module.exports = __webpack_public_path__ + "img/18.b60b358c.svg";